import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

interface RouterLinkProps extends Omit<LinkProps, 'to'> {
  to?: LinkProps['to'];
  href?: LinkProps['to'];
}

const RouterLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(({ to, href, ...rest }, ref) => {
  if (process.env.NODE_ENV !== 'production' && to == null && href == null) {
    console.warn('RouterLink: either `to` or `href` is required');
  }
  return <Link ref={ref} to={to ?? href ?? ''} {...rest} />;
});

RouterLink.displayName = 'RouterLink';

export default RouterLink;
